<template>
  <div class="members">
    <div class="left">
      <el-input
        v-model="personnelSelectionInput"
        class="personnelSelectionInput"
        placeholder="搜索人员"
        clearable
        :prefix-icon="Search"
      />
      <div class="memberList">
        <el-checkbox-group v-model="checkUserIds">
          <vxe-list auto-resize :data="memberList" :scroll-y="{ enabled: true }" class="center">
            <template #default="{ items }">
              <div class="childNodeItem" v-for="item in items" :key="item.id">
                <el-checkbox
                  @change="(checked: boolean) => selectChange(checked, item)"
                  :label="item.id"
                  :disabled="diff.includes(item.id)"
                  v-model="item.checked"
                >
                  {{ item.realName }}
                  <template v-if="item?.job === 2">（离职）</template>
                </el-checkbox>
              </div>
            </template>
          </vxe-list>
        </el-checkbox-group>
      </div>
    </div>
    <div class="right">
      <div class="top">
        <span>已选择{{ checkUserList.length }}项</span>
        <span class="clear" @click="clearAll">清空</span>
      </div>

      <div class="checkUserList" ref="scrollEl">
        <div class="checkUserList-item" v-for="item in showUserList" :key="item.id">
          <span>{{ item.realName }}</span>
          <template v-if="item?.job === 2">（离职）</template>
          <i v-if="!item?.disable" class="iconfont icon-close" @click="delItem(item.id)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useInfiniteScroll } from '@vueuse/core'
import { computed, ref, unref, watch, type PropType } from 'vue'
import { VxeList } from 'vxe-table'
import { Search } from '@element-plus/icons-vue'
import type { UserVOList } from '../type'
import { cloneDeep } from '@/utils/tools'
import { difference } from 'lodash-es'
const emit = defineEmits(['update:data', 'updateValue'])

const count = ref<number>(10)
const personnelSelectionInput = ref<string>('')
const checkUserList = ref<UserVOList[]>([])
const checkUserIds = ref<string[]>([])

const memberList = ref<UserVOList[]>([])
const scrollEl = ref<HTMLElement>(null)
const props = defineProps({
  data: {
    type: Array as PropType<UserVOList[]>,
    default: () => []
  },
  checkedUser: {
    type: Array as PropType<UserVOList[]>,
    default: () => []
  },
  disabledIds: {
    type: Array as PropType<string[]>,
    default: () => []
  },
  oldCheckUserIds: {
    type: Array as PropType<string[]>,
    default: () => []
  }
})
const diff = computed(() => {
  return difference(props.disabledIds, props.oldCheckUserIds)
})
const orginRoleData = computed(() => {
  return unref(props.data)
})
const showUserList = computed(() => {
  return checkUserList.value.slice(0, count.value)
})
useInfiniteScroll(
  scrollEl,
  () => {
    // load more
    if (showUserList.value.length >= checkUserList.value.length) return
    count.value += 30
  },
  { distance: 10 }
)
watch(
  () => props.data,
  newValue => {
    memberList.value = cloneDeep(newValue)
  },
  {
    deep: true
  }
)

// watch(() => props.checkedUser, (checkedUser) => {
//   checkUserList.value = checkedUser || []
//   checkUserIds.value = checkedUser.map(item => item.id) || []
// }, {
//   deep: true
// })

function selectChange(checked: boolean, item: any) {
  console.log(item, checkUserIds.value)
  item.checked = checked
  const findId = checkUserList.value.findIndex(el => el.id === item.id)
  if (findId !== -1) {
    checkUserList.value.splice(findId, 1)
  } else {
    checkUserList.value.push(item)
  }
  emit('updateValue', checkUserList.value)
}

function delItem(id: string) {
  const findId = checkUserList.value.findIndex(el => el.id === id)
  if (findId !== -1) {
    checkUserList.value.splice(findId, 1)
  }
  checkUserIds.value = checkUserIds.value.filter(item => item !== id)
  emit('updateValue', checkUserList.value)
}

function clearAll() {
  checkUserList.value = checkUserList.value.filter(item => item.disable)
  checkUserIds.value = []
  emit('updateValue', checkUserList.value)
}

watch(personnelSelectionInput, val => {
  console.log(orginRoleData, 'orginRoleData')
  memberList.value = orginRoleData.value?.filter(
    item => item.realName && item.realName.includes(val)
  )
})

function updateCheck(checkedUser: UserVOList[]) {
  console.log(checkedUser, 'laila')
  console.log(props)
  checkUserList.value = checkedUser || []
  checkUserIds.value = checkedUser.map(item => item.id) || []
}

onMounted(() => {
  memberList.value = cloneDeep(props.data)
})

defineExpose({
  updateCheck
})
</script>

<style lang="scss" scoped>
.members {
  @include flex-center(row, normal, normal);
  height: 100%;
  .left {
    flex: 1;
    border-right: 1px solid #ebeef5;
    padding: 16px 16px 16px 0;
    overflow: hidden;
    .memberList {
      overflow-y: auto;
      height: calc(100% - 38px);
      &::-webkit-scrollbar {
        display: none;
      }
      .childNodeItem {
        display: block;
        width: 100%;
      }
      .el-checkbox-group {
        height: 100%;
        .vxe-list {
          height: 100%;
          :deep(.vxe-list--virtual-wrapper) {
            height: 100%;
          }
        }
      }
    }
    .personnelSelectionInput {
      border-radius: 4px;
      :deep(.el-input__wrapper) {
        box-shadow: none;
        background: #f4f4f5;
      }
      margin-bottom: 13px;
    }
  }
  .right {
    flex: 1;
    padding: 16px 0 16px 16px;
    overflow-y: auto;
    font-size: $font-size-mini;
    color: $main-text-color;
    .top {
      @include flex-center(row, space-between, center);
      margin-bottom: 12px;
      .clear {
        color: $primary-color;
        cursor: pointer;
      }
    }
    .checkUserList {
      overflow-y: auto;
      height: calc(100% - 30px);
      &-item {
        display: inline-block;
        padding: 2px 6px 2px 10px;
        border-radius: 2px;
        background: #eef3ff;
        margin-right: 8px;
        margin-bottom: 8px;
        .icon-close {
          cursor: pointer;
          font-size: $font-size-mini;
          margin-left: 8px;
        }
      }
    }
  }
}
</style>
